import React from 'react';
import { Link } from 'react-router-dom';

// Shared right-rail promo card - matches the charcoal/spice-glow/gold-CTA
// pattern used by the challenges-listing and home-app prototype screens
// (host-cta-card / challenge-mini), reused here so real pages carry the
// same "look and touch".
const PromoCard = ({ label, title, sub, ctaText, to, state }) => (
  <div className="nmsl-promo-card">
    {label && <p className="nmsl-promo-label">{label}</p>}
    <p className="nmsl-promo-title">{title}</p>
    {sub && <p className="nmsl-promo-sub">{sub}</p>}
    {to && (
      <Link to={{ pathname: to }} state={state} className="nmsl-promo-btn" style={{ textDecoration: 'none', display: 'block' }}>
        {ctaText}
      </Link>
    )}
  </div>
);

export default PromoCard;
